import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { TfiClose } from "react-icons/tfi";
import { static_server, civs } from "../utils/constants";
import { useMatchContext } from "../context/match_context";

const GameResultsManagement = () => {
  const { loading, error, match, updateMatch } = useMatchContext();
  const [gameStep, setGameStep] = useState(0);
  const [showMapSelector, setShowMapSelector] = useState(false);
  const [showCivASelector, setShowCivASelector] = useState(false);
  const [showCivBSelector, setShowCivBSelector] = useState(false);

  const civilizations = civs.sort((a, b) =>
    a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
  );
  var gamesTemplate_PA3 = [
    {
      sequence: 1,
      gameAoe2Id: "",
      gameWinner: "",
      gameCivA: "generic_civ",
      gameCivB: "generic_civ",
      map: "cm_generic",
      gameRec: "",
    },
    {
      sequence: 2,
      gameAoe2Id: "",
      gameWinner: "",
      gameCivA: "generic_civ",
      gameCivB: "generic_civ",
      map: "cm_generic",
      gameRec: "",
    },
    {
      sequence: 3,
      gameAoe2Id: "",
      gameWinner: "",
      gameCivA: "generic_civ",
      gameCivB: "generic_civ",
      map: "cm_generic",
      gameRec: "",
    },
  ];

  var gamesTemplate_BO5 = [
    {
      sequence: 1,
      gameAoe2Id: "",
      gameWinner: "",
      gameCivA: "generic_civ",
      gameCivB: "generic_civ",
      map: "cm_generic",
      gameRec: "",
    },
    {
      sequence: 2,
      gameAoe2Id: "",
      gameWinner: "",
      gameCivA: "generic_civ",
      gameCivB: "generic_civ",
      map: "cm_generic",
      gameRec: "",
    },
    {
      sequence: 3,
      gameAoe2Id: "",
      gameWinner: "",
      gameCivA: "generic_civ",
      gameCivB: "generic_civ",
      map: "cm_generic",
      gameRec: "",
    },
    {
      sequence: 4,
      gameAoe2Id: "",
      gameWinner: "",
      gameCivA: "generic_civ",
      gameCivB: "generic_civ",
      map: "cm_generic",
      gameRec: "",
    },
    {
      sequence: 5,
      gameAoe2Id: "",
      gameWinner: "",
      gameCivA: "generic_civ",
      gameCivB: "generic_civ",
      map: "cm_generic",
      gameRec: "",
    },
  ];

  const [games, setGames] = useState([]);
  const [civA, setCivA] = useState(`generic_civ`);
  const [civB, setCivB] = useState(`generic_civ`);
  const [map, setMap] = useState(`cm_generic`);
  const [winner, setWinner] = useState("");

  const initializeGames = (games, template) => {
    var toRet = [...template];

    for (var index = 0; index < toRet.length; index++) {
      for (const temp of games) {
        if (toRet[index].sequence === temp.sequence) {
          toRet[index].gameAoe2Id = temp.gameAoe2Id;
          toRet[index].gameWinner = temp.gameWinner;
          toRet[index].gameCivA = temp.gameCivA;
          toRet[index].gameCivB = temp.gameCivB;
          toRet[index].map = temp.map;
          toRet[index].gameRec = temp.gameRec;
          break;
        }
      }
    }
    return toRet;
  };

  useEffect(() => {
    if (!loading && !error) {
      var gamesTemplate = {};
      if (match.gamesFormat === "PA3") {
        //console.log("Using PA3 template");
        gamesTemplate = gamesTemplate_PA3;
      } else {
        //console.log("Using BO5 template");
        gamesTemplate = gamesTemplate_BO5;
      }

      var temp = initializeGames(match.games, gamesTemplate);
      setGames([...temp]);
      setCivA(
        temp[gameStep].gameCivA ? temp[gameStep].gameCivA : `generic_civ`
      );
      setCivB(
        temp[gameStep].gameCivB ? temp[gameStep].gameCivB : `generic_civ`
      );
      setMap(temp[gameStep].map ? temp[gameStep].map : `cm_generic`);
      setWinner(temp[gameStep].gameWinner);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!loading && !error && games && games.length > 0) {
      setCivA(
        games[gameStep].gameCivA ? games[gameStep].gameCivA : `generic_civ`
      );
      setCivB(
        games[gameStep].gameCivB ? games[gameStep].gameCivB : `generic_civ`
      );
      setMap(games[gameStep].map ? games[gameStep].map : `cm_generic`);
      setWinner(games[gameStep].gameWinner);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameStep]);

  useEffect(() => {
    if (
      !loading &&
      !error &&
      gameStep >= 0 &&
      games &&
      games.length > 0 &&
      games[gameStep]
    ) {
      var tempGames = games;
      var game = { ...tempGames[gameStep] };
      if (
        game.gameCivA !== civA ||
        game.gameCivB !== civB ||
        game.map !== map ||
        game.gameWinner !== winner
      ) {
        game.gameCivA = civA;
        game.gameCivB = civB;
        game.map = map;
        game.gameWinner = winner;
        tempGames[gameStep] = game;
        //console.log(`GameResultsManagement :: updating games`);
        setGames([...tempGames]);
        updateMatch({ ...match, games: [...tempGames] });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [civA, civB, map, winner]);

  const selectMap = (mapName) => {
    //console.log(`Selected Map: ${mapName}`);
    setMap(mapName);
    setShowMapSelector(false);
  };

  const selectCivA = (civName) => {
    setCivA(civName);
    setShowCivASelector(false);
  };

  const selectCivB = (civName) => {
    setCivB(civName);
    setShowCivBSelector(false);
  };

  if (loading) {
    return <div>Cargando...</div>;
  }
  if (error) {
    return (
      <div>Se ha producido un error cargando la información de la partida</div>
    );
  }

  return (
    <Wrapper>
      {showMapSelector ? (
        <MapSelector>
          <div className="selector-container">
            <div
              className="close-icon"
              onClick={() => setShowMapSelector(false)}
            >
              <TfiClose />
            </div>
            <h3>Selecciona el mapa</h3>
            <div className="map-list">
              <div className="map-item" onClick={() => selectMap("LEA_arabia")}>
                <img
                  src={`${static_server}/maps/LEA_arabia.png`}
                  alt="arabia"
                />
                <span>Arabia</span>
              </div>
              <div className="map-item" onClick={() => selectMap("LEA_Koala")}>
                <img src={`${static_server}/maps/LEA_Koala.png`} alt="Koala" />
                <span>Koala</span>
              </div>

              <div className="map-item" onClick={() => selectMap("LEA_Nomada")}>
                <img
                  src={`${static_server}/maps/LEA_Nomada.png`}
                  alt="Nómada"
                />
                <span>Nómada</span>
              </div>

              <div
                className="map-item"
                onClick={() => selectMap("LEA_Northern_Islands")}
              >
                <img
                  src={`${static_server}/maps/LEA_Northern_Islands.png`}
                  alt="Northern Islands"
                />
                <span>Northern Islands</span>
              </div>

              <div className="map-item" onClick={() => selectMap("LEA_Arena")}>
                <img src={`${static_server}/maps/LEA_Arena.png`} alt="Arena" />
                <span>Arena</span>
              </div>

              <div className="map-item" onClick={() => selectMap("LEA_Shoals")}>
                <img
                  src={`${static_server}/maps/LEA_Shoals.png`}
                  alt="Shoals"
                />
                <span>Shoals</span>
              </div>

              <div
                className="map-item"
                onClick={() => selectMap("LEA_Sunburn")}
              >
                <img
                  src={`${static_server}/maps/LEA_Sunburn.png`}
                  alt="Sunburn"
                />
                <span>Sunburn</span>
              </div>
            </div>
          </div>
        </MapSelector>
      ) : (
        ""
      )}
      {showCivASelector ? (
        <CivSelector>
          <div className="selector-container">
            <div
              className="close-icon"
              onClick={() => setShowCivASelector(false)}
            >
              <TfiClose />
            </div>
            <h3>Selecciona la civilización</h3>
            <div className="civ-list">
              {civilizations.map((civ) => (
                <div
                  className="civ-item"
                  onClick={() => selectCivA(civ.name.toLocaleLowerCase())}
                  key={`civselectorA-civId-${civ.id}`}
                >
                  <img
                    src={`${static_server}/civs/${civ.name.toLocaleLowerCase()}.png`}
                    alt={civ.name}
                  />
                  <span>{civ.name}</span>
                </div>
              ))}
            </div>
          </div>
        </CivSelector>
      ) : (
        ""
      )}
      {showCivBSelector ? (
        <CivSelector>
          <div className="selector-container">
            <div
              className="close-icon"
              onClick={() => setShowCivBSelector(false)}
            >
              <TfiClose />
            </div>
            <h3>Selecciona la civilización</h3>
            <div className="civ-list">
              {civs.map((civ) => (
                <div
                  className="civ-item"
                  onClick={() => selectCivB(civ.name.toLocaleLowerCase())}
                  key={`civselectorB-civId-${civ.id}`}
                >
                  <img
                    src={`${static_server}/civs/${civ.name.toLocaleLowerCase()}.png`}
                    alt={civ.name}
                  />
                  <span>{civ.name}</span>
                </div>
              ))}
            </div>
          </div>
        </CivSelector>
      ) : (
        ""
      )}
      {match.gamesFormat === "PA3" ? (
        <GamesHeader>
          <div
            className={`game-selector ${gameStep === 0 ? "active" : ""}`}
            onClick={() => setGameStep(0)}
          >
            mapa 1
          </div>
          <div
            className={`game-selector ${gameStep === 1 ? "active" : ""}`}
            onClick={() => setGameStep(1)}
          >
            mapa 2
          </div>
          <div
            className={`game-selector ${gameStep === 2 ? "active" : ""}`}
            onClick={() => setGameStep(2)}
          >
            mapa 3
          </div>
        </GamesHeader>
      ) : (
        <GamesHeader>
          <div
            className={`game-selector ${gameStep === 0 ? "active" : ""}`}
            onClick={() => setGameStep(0)}
          >
            mapa 1
          </div>
          <div
            className={`game-selector ${gameStep === 1 ? "active" : ""}`}
            onClick={() => setGameStep(1)}
          >
            mapa 2
          </div>
          <div
            className={`game-selector ${gameStep === 2 ? "active" : ""}`}
            onClick={() => setGameStep(2)}
          >
            mapa 3
          </div>
          <div
            className={`game-selector ${gameStep === 3 ? "active" : ""}`}
            onClick={() => setGameStep(3)}
          >
            mapa 4
          </div>
          <div
            className={`game-selector ${gameStep === 4 ? "active" : ""}`}
            onClick={() => setGameStep(4)}
          >
            mapa 5
          </div>
        </GamesHeader>
      )}
      <GamesResult>
        <div className="game">
          <div className="row">
            <div className="civ" onClick={() => setShowCivASelector(true)}>
              <img
                src={`${static_server}/civs/${civA.toLocaleLowerCase()}.png`}
                alt={civA}
                title={civA}
              />
              <span>{civA !== "generic_civ" ? civA : ""}</span>
            </div>
            <div className="map" onClick={() => setShowMapSelector(true)}>
              <img
                src={`${static_server}/maps/${map}.png`}
                alt={map}
                title={map}
              />
              <span>{map !== "cm_generic" ? map.replace("LEA_", "") : ""}</span>
            </div>
            <div className="civ" onClick={() => setShowCivBSelector(true)}>
              <img
                src={`${static_server}/civs/${civB.toLocaleLowerCase()}.png`}
                alt={civB}
                title={civB}
              />
              <span>{civB !== "generic_civ" ? civB : ""}</span>
            </div>
          </div>
          <div className="row">
            <div className="winner">
              <p>Indícanos el ganador de la partida</p>
              <div className="winner-selector">
                <div
                  className={`winner-selector-player ${
                    winner === match.playerAid ? "winner-selected" : ""
                  }`}
                  onClick={() => setWinner(match.playerAid)}
                >
                  {match.playerAusername}
                </div>
                <div
                  className={`winner-selector-player ${
                    winner === match.playerBid ? "winner-selected" : ""
                  }`}
                  onClick={() => setWinner(match.playerBid)}
                >
                  {match.playerBusername}
                </div>
              </div>
            </div>
          </div>
        </div>
      </GamesResult>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;
const MapSelector = styled.div`
  position: fixed; /* Sit on top of the page content */
  /*display: none; /*Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  display: flex;
  justify-content: center;
  align-items: center;

  .close-icon {
    width: 100%;
    z-index: 10;
    color: var(--clr-black);
    display: flex;
    justify-content: flex-end;
    cursor: pointer;

    *:hover {
      animation: pulse 2s infinite;
    }

    @keyframes pulse {
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
      }

      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
      }

      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
      }
    }
  }

  .selector-container {
    width: 80%;
    height: 80%;
    background-color: var(--clr-grey-1);
    z-index: 5;
    color: var(--clr-black);
    padding: 2rem;

    .map-list {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      height: 80%;
    }

    .map-item {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 2rem;
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);

      img {
        width: 10rem;
      }
      span {
        color: var(--clr-black);
      }
    }
    .map-item:hover {
      -webkit-filter: grayscale(0);
      filter: grayscale(0);
    }
  }
`;
const CivSelector = styled.div`
  position: fixed; /* Sit on top of the page content */
  /*display: none; /*Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  display: flex;
  justify-content: center;
  align-items: center;

  .close-icon {
    width: 100%;
    z-index: 10;
    color: var(--clr-black);
    display: flex;
    justify-content: flex-end;
    cursor: pointer;

    *:hover {
      animation: pulse 2s infinite;
    }

    @keyframes pulse {
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
      }

      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
      }

      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
      }
    }
  }

  .selector-container {
    width: 80%;
    height: 80%;
    background-color: var(--clr-grey-1);
    z-index: 5;
    color: var(--clr-black);
    padding: 2rem;
    overflow: auto;

    .civ-list {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      height: 80%;
    }

    .civ-item {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 2rem;
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);

      img {
        width: 6rem;
      }
      span {
        color: var(--clr-black);
      }
    }
    .civ-item:hover {
      -webkit-filter: grayscale(0);
      filter: grayscale(0);
    }
  }
`;
const GamesHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .game-selector {
    width: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 6rem;
    margin-right: 3rem;
    margin-bottom: 3rem;
    cursor: pointer;
  }

  .active {
    border-bottom: 2px solid var(--clr-primary);
  }
  @media (max-width: 450px) {
    justify-content: flex-start;
    .game-selector {
      margin-right: 1.5rem;
      margin-bottom: 1.5rem;
    }
  }
`;
const GamesResult = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .row {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.5rem;
    border: 1px solid white;
  }
  .civ {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 2rem;
    margin-right: 2rem;
    text-align: center;

    img {
      width: 4rem;
    }
    img:hover {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
    }
  }
  .map {
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    margin-left: 2rem;
    margin-right: 2rem;
    text-align: center;
    align-items: center;
    img {
      width: 6rem;
      height: 4rem;
    }
    img:hover {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
    }
  }
  .winner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .winner-selector {
    display: flex;
  }
  .winner-selector-player {
    margin: 1rem;
    cursor: pointer;
  }
  .winner-selector-player:hover {
    color: var(--clr-player-winner);
  }
  .winner-selected {
    color: var(--clr-player-winner);
    border: 1px solid var(--clr-dark-violet);
  }

  @media (max-width: 450px) {
    .row {
      border: none;
    }
  }
`;

export default GameResultsManagement;
